import { MainMenu } from '../components/mainMenu/MainMenu';


export const App = ({ options }) => {
  MainMenu();
};